import React from 'react';
import Component from '../../../ui-components/Component';
import { withResizer ,withTranslations} from '../../../HoCs';
import Page from '../../../ui-components/Page';
import styles from './styles';
import OTAFlow from './components/OTAFlow';
import { getCookie, getQueryParams } from '../../../utils';
import pages, { getRouteForPage } from '../../../PageEnums';
import CyclicFooter from '../../../ui-components/Banners/CyclicFooter';
import { hmsSelfOnboardingEnabled } from '../../../config/countryConfig';
import { forceLogout } from '../../../services/Network';


class PropertyCreate extends Component {

    queryParams = getQueryParams();
    translation_key = 'properties_translations';
    state = {
        mode: 'none',
    };

    styles = styles;
    
    componentDidMount = () => hmsSelfOnboardingEnabled() && forceLogout();
    
    modeSetter = mode => () => this.setState({ mode });

    // TODO: Fix route
    getPropertyRoute = (id) => getRouteForPage(pages.PROPERTIES,id+'?show_help=true');

    render = () => {
        return <Page title={this.gc('add_a_property')} contentStyle={{ position: 'relative', overflowY: 'hidden' }} renderFooter={() => <CyclicFooter style={this.gs('footer')} />}>
            
                <OTAFlow
                    backRoute={getRouteForPage(pages.PROPERTIES)}
                    className='fillSpace'
                    finalPageRedirection={this.getPropertyRoute}
                    auto={this.queryParams.auto}
                    skipOta={this.queryParams.skip_ota}
                    gc={this.gc}
                />
                
        </Page>
    };

}

export default withResizer(withTranslations(PropertyCreate));
